import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import {
  GetBranchParameterRequestParams,
  GetBranchParameterResponse,
} from '../../models/management.model';

@Injectable({
  providedIn: 'root',
})
export class ManagementService {
  apiUrl = environment.API_URL + 'internal/management/';

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
  ) {}

  getCustomerHeader() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.tokenService.getComponentCodeToken(),
      'Accept-Language': 'pt-BR',
    });
  }

  public getBranchParameter({
    branchCodeList,
    parameterCodeList,
  }: GetBranchParameterRequestParams): Observable<GetBranchParameterResponse> {
    let httpParams = new HttpParams();

    branchCodeList.forEach((code) => {
      httpParams = httpParams.append('branchCodeList', code.toString());
    });

    parameterCodeList.forEach((param) => {
      httpParams = httpParams.append('parameterCodeList', param.toString());
    });

    return this.httpClient.get<GetBranchParameterResponse>(
      `${this.apiUrl}v2/branch-parameter`,
      {
        headers: this.getCustomerHeader(),
        params: httpParams,
      },
    );
  }
}
